import * as React from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import ButtonStandard from "../ButtonStandard";
import "./OutPutsInfo.css";

 //@ts-ignore
import pdfEng from "../../assets/pdf/SCW_Info_Eng.pdf";
 //@ts-ignore
import pdfCy from "../../assets/pdf/SCW_Info_Cymraeg.pdf";

type InfoProps = {
    locale: string[2]
}

class OutPutsInfo extends React.Component<InfoProps> {  

    render() {

        const openPDF = () => {
            switch (this.props.locale) {

                case "en": return window.open(pdfEng, '_blank');
                case "cy": return window.open(pdfCy, '_blank');

            }
        }

        return (

            <div className="container-info-button-standard">
                <ButtonStandard iconName="info"
                    onClick={openPDF}
            />
            </div>
        );

    }
}

const mapStateToProps =
    (state: any) => (
        { locale: state.i18n.locale }
    );

export default connect(mapStateToProps)(OutPutsInfo);


